module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bakery_aea3e0.jpg";